export default __webpack_public_path__ + "1c44747923fff90aa9368e2b11ac2b1d.png";